"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperienceVoucherNormalizedSchema = exports.VoucherSchema = exports.MonetaryVoucherSchema = exports.ExperienceVoucherSchema = exports.VoucherBaseSchema = exports.PriceSchema = void 0;
var zod_1 = __importDefault(require("zod"));
exports.PriceSchema = zod_1.default.object({
    amount: zod_1.default.number(),
    currencyCode: zod_1.default.string(),
    prefix: zod_1.default.string().optional(),
    suffix: zod_1.default.string().optional(),
});
exports.VoucherBaseSchema = zod_1.default.object({
    id: zod_1.default.number(),
    uuid: zod_1.default.string().optional(),
    code: zod_1.default.string(),
    redemptionTotal: exports.PriceSchema,
    redemptionDueDate: zod_1.default.string().optional(),
    redemptionId: zod_1.default.string().optional(),
    redeemedAt: zod_1.default.string().optional(),
    name: zod_1.default.string().optional(),
});
exports.ExperienceVoucherSchema = exports.VoucherBaseSchema.extend({
    orderItem: zod_1.default.union([zod_1.default.number(), zod_1.default.string()]).nullish(),
    basketItem: zod_1.default.union([zod_1.default.number(), zod_1.default.string()]).nullish(),
});
exports.MonetaryVoucherSchema = exports.VoucherBaseSchema;
exports.VoucherSchema = zod_1.default.union([exports.ExperienceVoucherSchema, exports.MonetaryVoucherSchema]);
exports.ExperienceVoucherNormalizedSchema = exports.ExperienceVoucherSchema.transform(function (data) {
    var _a;
    return (__assign(__assign({}, data), { itemId: (_a = data.basketItem) !== null && _a !== void 0 ? _a : data.orderItem }));
});
